/** The only publish_source values this page maps. Anything else, including null, shows nothing. */
export const PUBLISH_SOURCE_COMMISSIONER = 'verified_live_handoff_commissioner';
export const PUBLISH_SOURCE_AUTOPILOT = 'verified_live_handoff_autopilot';

export function publishSourceLabel(publishSource: string | null | undefined): string | null {
  if (publishSource === PUBLISH_SOURCE_COMMISSIONER) {
    return 'Published by the commissioner';
  }
  if (publishSource === PUBLISH_SOURCE_AUTOPILOT) {
    return 'Published automatically';
  }
  return null;
}
